export const DEFAULT_ABOUT_PAGE = {
  sections: [
    {
      id: "intro",
      type: "intro",
      title: "PANCHALI JEWELS",
      visible: true,
      theme: "light",
      textAlign: "center",
      icon: "",
      imageUrl: "",
      imageAlt: "",
      items: [
        {
          id: "intro-paragraph-1",
          visible: true,
          html: "Welcome to PANCHALI JEWELS, your one-stop jewelry hub! &#127775; Explore a vast collection of Imitation, Brass, Steel, Silver, Gold and Platinum (plain and studded) jewelry, catering to every style and budget. From affordable fashion pieces to luxurious masterpieces, we&apos;ve got you sparkle covered! &#128142;",
        },
        {
          id: "intro-paragraph-2",
          visible: true,
          html: "Pioneering a unique shopping experience, we&apos;re proud to introduce India&apos;s first-ever jewelry platform where you can find everything from a tiny pin to a stunning piano setting - all under one roof! &#127929;&#10024; Whether you&apos;re looking for everyday essentials, special occasion pieces, or investing in timeless treasures, we&apos;ve got you covered.",
        },
        {
          id: "intro-paragraph-3",
          visible: true,
          html: "Be among the first to experience this revolutionary concept, where diversity meets elegance, and affordability meets luxury. From the smallest stud to exquisite diamond necklaces, and from trendy imitations to high-end gold and diamond ornaments, our vast collection is curated to cater to your every whim. Get ready to discover, indulge, and shine with us! &#128522;",
        },
      ],
    },
    {
      id: "custom-jewelry",
      type: "card",
      title: "Customized Jewelry Making",
      visible: true,
      theme: "gradient",
      textAlign: "left",
      icon: "&#10024;",
      imageUrl: "",
      imageAlt: "",
      items: [
        {
          id: "custom-jewelry-paragraph-1",
          visible: true,
          html: "At Panchali Jewels, we understand that every individual is unique, and so should their jewelry. That&apos;s why we offer customized jewelry making services, where our skilled artisans work closely with you to bring your vision to life.",
        },
        {
          id: "custom-jewelry-paragraph-2",
          visible: true,
          html: "From designing a bespoke piece to recreating a family heirloom, our custom jewelry services allow you to tell your story through a personalized piece of jewelry.",
        },
      ],
    },
    {
      id: "our-promise",
      type: "split",
      title: "Our Promise",
      visible: true,
      theme: "gradient",
      textAlign: "left",
      icon: "",
      imageUrl: "",
      imageAlt: "Our Promise",
      items: [
        {
          id: "our-promise-paragraph-1",
          visible: true,
          html: "We promise to deliver exceptional quality, attention to details, and a seamless customer experience.",
        },
        {
          id: "our-promise-paragraph-2",
          visible: true,
          html: "Our team of expert craftsmen and designers are dedicated to creating jewelry that not only sparkles but also stands the trend, taste and test of time.",
        },
      ],
    },
    {
      id: "our-values",
      type: "card",
      title: "Our Values",
      visible: true,
      theme: "gradient",
      textAlign: "left",
      icon: "&#128142;",
      imageUrl: "",
      imageAlt: "",
      items: [
        {
          id: "our-values-paragraph-1",
          visible: true,
          html: "At Panchali Jewels, we value creativity, innovation, and customer satisfaction.",
        },
        {
          id: "our-values-paragraph-2",
          visible: true,
          html: "We&apos;re committed to sustainability, responsible sourcing, and eco-friendly practices in our jewelry making process.",
        },
      ],
    },
    {
      id: "why-choose-us",
      type: "grid",
      title: "Why Choose Us",
      visible: true,
      theme: "gradient",
      textAlign: "center",
      icon: "",
      imageUrl: "",
      imageAlt: "",
      items: [
        { id: "why-choose-1", visible: true, html: "Unique and exclusive designs" },
        { id: "why-choose-2", visible: true, html: "High-quality materials and craftsmanship" },
        { id: "why-choose-3", visible: true, html: "Personalized customer service" },
        { id: "why-choose-4", visible: true, html: "Customized jewelry making options" },
        { id: "why-choose-5", visible: true, html: "Fast and secure shipping" },
        { id: "why-choose-6", visible: true, html: "Above all, customer satisfaction" },
      ],
    },
  ],
};

export const normalizeAboutSections = (data) =>
  Array.isArray(data?.sections)
    ? data.sections.map((section) => ({
        id: String(section?.id || `${section?.type || "card"}-section`),
        type: String(section?.type || "card"),
        title: String(section?.title || ""),
        visible: typeof section?.visible === "boolean" ? section.visible : true,
        theme: String(section?.theme || "light"),
        textAlign: String(section?.textAlign || "left"),
        icon: String(section?.icon || ""),
        imageUrl: String(section?.imageUrl || ""),
        imageAlt: String(section?.imageAlt || ""),
        items: Array.isArray(section?.items)
          ? section.items.map((item, index) => ({
              id: String(item?.id || `${section?.id || "section"}-item-${index + 1}`),
              html: String(item?.html || ""),
              visible: typeof item?.visible === "boolean" ? item.visible : true,
            }))
          : [],
      }))
    : DEFAULT_ABOUT_PAGE.sections;
